import { OriginEnum } from "../enums/OriginEnum";

export const integrationToDisplayName = [
  OriginEnum.VNDA,
  OriginEnum.BLINGV3,
  OriginEnum.INTELIPOST,
  OriginEnum.ABBIAMO,
  OriginEnum.BAGY
]

export const usersToDisplayName = [
  "20484272-ae05-4893-b48e-77adf5e283b8", // Grupo Soma
  "3f8ac420-0aaf-4402-bb7e-adc61fe0effd", // Brockton
]
